/** Manual line under a product quote_item (not decoration or setup_cost) */
export const QUOTE_SUB_ITEM_TYPE_CUSTOM_LINE = 'custom_line' as const

export const TABLE_COL_WIDTHS = {
  description: 'minmax(0, 1fr)',
  unitPrice: '120px',
  qty: '100px',
  total: '100px',
} as const

export const CELL_BASE = 'py-2 px-5 text-sm text-gray-700'
export const CELL_DESCRIPTION = `${CELL_BASE} align-center`
export const CELL_UNIT_PRICE = `${CELL_BASE} align-center text-center`
export const CELL_QTY = `${CELL_BASE} align-middle`
export const CELL_TOTAL = `${CELL_BASE} align-middle text-right`

/** Shared cell chrome for isolated quote item rows */
export const QUOTE_ITEM_ROW_STANDALONE =
  'border-0 hover:bg-transparent [&>td]:border [&>td]:border-border [&>td]:bg-card [&>td]:py-4 [&>td:first-child]:rounded-l-card [&>td:first-child]:border-r-0 [&>td:not(:first-child):not(:last-child)]:border-x-0 [&>td:last-child]:rounded-r-card [&>td:last-child]:border-l-0 max-sm:[&>td:first-child]:rounded-l-none max-sm:[&>td:first-child]:rounded-t-card max-sm:[&>td:first-child]:border-r max-sm:[&>td:first-child]:border-b-0 max-sm:[&>td:not(:first-child):not(:last-child)]:border-x max-sm:[&>td:not(:first-child):not(:last-child)]:border-y-0 max-sm:[&>td:last-child]:rounded-r-none max-sm:[&>td:last-child]:rounded-b-card max-sm:[&>td:last-child]:border-l max-sm:[&>td:last-child]:border-t-0'

export const QUOTE_ITEM_ROW_GROUP_START =
  'border-0 hover:bg-transparent [&>td]:border [&>td]:border-border [&>td]:bg-card [&>td]:py-3.5 [&>td:first-child]:rounded-tl-card [&>td:first-child]:border-r-0 [&>td:not(:first-child):not(:last-child)]:border-x-0 [&>td:last-child]:rounded-tr-card [&>td:last-child]:border-l-0'

export const QUOTE_ITEM_ROW_GROUP_MIDDLE =
  'border-0 hover:bg-transparent [&>td]:border-x [&>td]:border-b [&>td]:border-border [&>td]:bg-muted/40 [&>td]:py-2 [&>td:first-child]:border-l [&>td:last-child]:border-r'

export const QUOTE_ITEM_ROW_GROUP_END =
  'border-0 hover:bg-transparent [&>td]:border [&>td]:border-border [&>td]:bg-muted/40 [&>td]:py-2 [&>td:first-child]:rounded-bl-card [&>td:first-child]:border-r-0 [&>td:not(:first-child):not(:last-child)]:border-x-0 [&>td:last-child]:rounded-br-card [&>td:last-child]:border-l-0'

